import {
  FeedstockBmpPotentialCod,
  FeedstockBmpPotentialCodPropName
} from '../../../../../models/project/feedstock/feedstock-bmp-potential/feedstock-bmp-potential-type-models/feedstock-bmp-potential-cod.model';
import { ProjectValidationUnit } from '../../../../../models/data-structures/project-validation';
import { ValidationInterface } from '../../../validation.interface';
import { UnitValueValidation } from '../../unit-value.validation';

export class FeedstockBmpPotentialCodValidation implements ValidationInterface {
  /** The BMP potential COD obj that is being validated */
  bmpPotentialCod: FeedstockBmpPotentialCod;

  /**
   * Sets the BMP potential COD obj that will be used for validation
   * @param bmpPotentialCod will be used to set the current BMP potential COD obj
   */
  constructor(bmpPotentialCod: FeedstockBmpPotentialCod) {
    if (!bmpPotentialCod) throw Error('invalid bmp potential COD provided for validation');
    this.bmpPotentialCod = new FeedstockBmpPotentialCod(bmpPotentialCod);
  }

  /**
   * Get a validation unit containing the validation data for the current BMP potential COD obj
   * @param validationUnit, if provided will have the validation for the current BMP potential COD
   * added to it. If it is not provided a new validation unit will be returned.
   */
  getValidation(validationUnit = new ProjectValidationUnit()): ProjectValidationUnit {
    if (!this.bmpPotentialCod) throw Error('unable to validate BMP potential COD');
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialCod.cod).getValidation(),
      FeedstockBmpPotentialCodPropName.cod
    );
    validationUnit.addModuleResults(
      new UnitValueValidation(this.bmpPotentialCod.biodegradability).getValidation(),
      FeedstockBmpPotentialCodPropName.biodegradability
    );
    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current BMP potential COD obj is valid
   */
  isValid(): boolean {
    return this.getValidation().isValid;
  }
}
